import React from 'react';
import { useIntl } from 'react-intl';
import { fmtMoney, fmtPrice, fmtQty } from '../../utils/format';

/**
 * props:
 * - data
 * - onWithdrawClick
 */
function WalletRow(props) {

    const { formatMessage } = useIntl();
    const t = (id) => formatMessage({ id });

    return (
        <tr>
            <td data-label={t('common.symbol')}>
                <span
                    role="button"
                    title="Favorite"
                    onClick={() => props.onToggleFav && props.onToggleFav(props.data.symbol)}
                    style={{ cursor: 'pointer', marginRight: 8, color: props.isFav ? '#f5c451' : '#55556a' }}>
                    {props.isFav ? '★' : '☆'}
                </span>
                <img alt={props.data.symbol} className="me-2" width={16} src={`/img/icons/black/${props.data.symbol.toLowerCase()}.svg`} />
                {props.data.symbol}
            </td>
            <td data-label={t('wallet.available')} className="num">
                {fmtQty(props.data.available)}
            </td>
            <td data-label={t('wallet.locked')} className="num">
                {parseFloat(props.data.onOrder) > 0 ? fmtQty(props.data.onOrder) : '-'}
            </td>
            <td data-label={t('wallet.fiatTotal')} className="num">
                {props.data.fiatEstimate ? fmtMoney(props.data.fiatEstimate) : '-'}
            </td>
            <td data-label={t('wallet.avgPrice')} className="num">
                {props.data.avg ? fmtPrice(props.data.avg) : '-'}
            </td>
            <td data-label={t('common.actions')} className="gh-td-actions">
                {props.canConvert && props.data.symbol !== 'USDC' && (
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-primary py-0 px-2"
                        onClick={() => props.onConvert && props.onConvert(props.data.symbol)}>
                        → USDC
                    </button>
                )}
            </td>
        </tr>
    )
}

export default WalletRow;
